export const UPDATE_SELECTED_SERVICE = 'UPDATE_SELECTED_SERVICE'
export const UPDATE_NOTE_FOR_SERVICE = 'UPDATE_NOTE_FOR_SERVICE'

export const ADD_CUSTOM_SERVICE_TO_ORDER = 'ADD_CUSTOMER_SERVICE_TO_ORDER'
export const TOGGLE_CUSTOM_SERVICE_TO_ORDER = 'TOGGLE_CUSTOM_SERVICE_TO_ORDER'

export const SUBMIT_SERVICE_ORDER = 'SUBMIT_SERVICE_ORDER'
export const SUBMIT_SERVICE_ORDER_SUCCESS = 'SUBMIT_SERVICE_ORDER_SUCCESS'
export const SUBMIT_SERVICE_ORDER_FAIL = 'SUBMIT_SERVICE_ORDER_FAIL'
